<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <!-- v6.4.2: Nova UI do toast com cores customizadas para dark/light mode -->
    <div
      class="toast-alert shadow-lg rounded-xl flex flex-col items-center gap-4 mb-2 max-w-[28rem] min-w-[18rem] px-8 py-6 text-center"
    >
      <!-- Mensagem principal -->
      <div class="text-base font-medium text-white">
        {{ message }}
      </div>
      
      <!-- Botão de ação -->
      <div v-if="action">
        <router-link
          v-if="action.type == 'link'"
          :to="action.to"
          class="toast-button inline-block px-6 py-2.5 rounded-full text-white font-medium cursor-pointer select-none transition-all hover:opacity-90"
        >
          {{ action.message }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Toast Alert - Background e Borda Externa */
.toast-alert {
  /* Light mode: #125A97 */
  background-color: #125A97;
  /* Borda externa roxa #7439ec */
  border: 2px solid #7439ec;
}

/* Dark mode */
.dark .toast-alert {
  /* Dark mode: #3e4348 */
  background-color: #3e4348;
}

/* Toast Button - Visualizar Mensagem */
.toast-button {
  /* Cor do botão: #0E3555 */
  background-color: #0E3555;
  /* Borda do botão: #6d6868 */
  border: 1px solid #6d6868;
}

.toast-button:hover {
  background-color: #0a2a45;
}
</style>
